// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MarketplaceLayout_wrapper__Se6Fr","marketplace-page--wrapper":"MarketplaceLayout_marketplace-page--wrapper__1lsPz"};